import { initializeApp } from "firebase/app";
import {
  getFirestore,
  doc,
  setDoc,
  addDoc,
  collection,
} from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// const firebaseConfig = {
//   apiKey: "AIzaSyCLUYs-yYAfgB5DINyvOatEg2kisysam1w",
//   authDomain: "doctele-edc27.firebaseapp.com",
//   projectId: "doctele-edc27",
//   storageBucket: "doctele-edc27.firebasestorage.app",
//   messagingSenderId: "998978084367",
//   appId: "1:998978084367:web:0db5c9e967493497338d7a"
// };

const firebaseConfig = {
  apiKey: "AIzaSyAEsrHK3k5gCS7ZnXXlvsoqz0DZFKFwjTk",
  authDomain: "pushnotification-26fdb.firebaseapp.com",
  projectId: "pushnotification-26fdb",
  storageBucket: "pushnotification-26fdb.firebasestorage.app",
  messagingSenderId: "687591429394",
  appId: "1:687591429394:web:2efc71c01eefc60035cfcb",
  measurementId: "G-V2B83EBP07",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
export const messaging = getMessaging(app);

// For FCM Token Request
export const getFcmToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    const token = await getToken(messaging, {
      vapidKey:
        "BAVE9PdQhTayMEIwvmmDkQ9ZSKDNcAW7nmkcVopCbEEvM4jX370bcwjNiwSfjKJ4mPDNiXpXSr_0m1Eoxk1bwaI",
    });

    return token;
  } catch (err) {
    console.log("FCM Token Error", err);
    return null;
  }
};

export const onForegroundMessage = (cb) => {
  return onMessage(messaging, cb);
};

export const notifyPatient = async (
  patientId,
  roomId,
  patientName,
  doctorId
) => {
  const callRef = doc(db, "calls", patientId);
  await setDoc(
    callRef,
    {
      incomingCall: {
        callerName: patientName,
        callerId: patientId,
        role: "patient",
        roomId: roomId,
        receiverId: doctorId,
        timestamp: Date.now(),
      },
    },
    { merge: true }
  );
};

export const notifyDoctor = async (patientId, appointmentId, doctorId) => {
  await addDoc(collection(db, "medicalrecordShare"), {
    apptId: appointmentId,
    senderId: patientId,
    receiverId: doctorId,
    timestamp: Date.now(),
    handled: false,
  });
};

export { app, db };
